import { api } from 'shared/api'

import {
  ContentMapSchemas,
  CustomEventsSchema,
  OtnReasonsSchema,
  UserFieldsSchema,
  GlobalFieldsSchema,
  PageTagsSchema,
} from './schemas'

export const ContentMapApi = {
  fetchItem: api.base.createGet({
    url: '/{pageId}/map/get',
    schemas: ContentMapSchemas,
  }),
  fetchCustomEvents: api.base.createGet({
    url: '/{pageId}/customEvents/list',
    schemas: CustomEventsSchema,
  }),
  fetchOtnReasons: api.base.createGet({
    url: '/{pageId}/oneTimeNotifyReason/list',
    schemas: OtnReasonsSchema,
  }),
  fetchUserFields: api.base.createGet({
    url: '/{pageId}/customFields/list',
    schemas: UserFieldsSchema,
  }),
  fetchGlobalFields: api.base.createGet({
    url: '/{pageId}/globalFields/list',
    schemas: GlobalFieldsSchema,
  }),
  fetchPageTags: api.base.createGet({
    url: '/{pageId}/tags/list',
    schemas: PageTagsSchema,
  }),
}
